'use client';

import React, { useEffect, useRef } from 'react';

import { LoadScriptProps } from './models';

export const LoadScript = ({ contentData }: LoadScriptProps) => {
    const contentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!contentRef.current) return;
        contentRef.current.innerHTML = contentData.script;
        const scripts = contentRef.current.querySelectorAll('script');
        scripts.forEach((oldScript) => {
            const newScript = document.createElement('script');
            Array.from(oldScript.attributes).forEach((attr) => newScript.setAttribute(attr.name, attr.value));
            newScript.appendChild(document.createTextNode(oldScript.innerHTML));
            oldScript.parentNode?.replaceChild(newScript, oldScript);
        });
    }, [contentData.script]);

    return <div ref={contentRef} />;
};
